module.exports = __webpack_public_path__ + "static/media/bgHome.277b9b3b.png";